import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=3d67c95a&scoped=true&"
import script from "./BookPage.vue?vue&type=script&lang=js&"
export * from "./BookPage.vue?vue&type=script&lang=js&"
import style0 from "./BookPage.vue?vue&type=style&index=0&id=3d67c95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67c95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d67c95a')) {
      api.createRecord('3d67c95a', component.options)
    } else {
      api.reload('3d67c95a', component.options)
    }
    module.hot.accept("./BookPage.vue?vue&type=template&id=3d67c95a&scoped=true&", function () {
      api.rerender('3d67c95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/epc/BookPage.vue"
export default component.exports